import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ing_2.svg")